export const DEFAULT_DAILY_AI_MENTOR_TOKEN_LIMIT = 20000;

export const formatTokenCount = (value) => {
  if (!Number.isFinite(value)) return "";
  return new Intl.NumberFormat("en-IN").format(value);
};

export const getPlanDailyAIMentorTokenLimit = (plan = {}) => {
  const candidates = [
    plan?.aiDailyTokenLimit,
    plan?.dailyAiTokenLimit,
    plan?.aiMentorDailyTokenLimit,
    plan?.limits?.aiDailyTokens,
  ];

  const matched = candidates.find(
    (value) => Number.isFinite(Number(value)) && Number(value) > 0
  );

  return matched
    ? Number(matched)
    : DEFAULT_DAILY_AI_MENTOR_TOKEN_LIMIT;
};
